if (!customElements.get('hw-service-page')) {
  customElements.define('hw-service-page', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const link = event.target.closest('a[href^="#hw-service-"]');
        if (!link) return;
        const target = this.querySelector(link.getAttribute('href'));
        if (target && target.tagName === 'DETAILS') target.open = true;
      };
      this.onHash = () => {
        if (!location.hash.startsWith('#hw-service-topic-')) return;
        const target = this.querySelector(location.hash);
        if (target && target.tagName === 'DETAILS') target.open = true;
      };
      this.addEventListener('click', this.onClick);
      window.addEventListener('hashchange', this.onHash);
      this.onHash();
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.remove('is-pending');
              this.observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.06 });
        this.querySelectorAll('[data-hw-reveal]').forEach((element) => {
          element.classList.add('is-pending');
          this.observer.observe(element);
        });
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('hashchange', this.onHash);
    }
  });
}
